'use client';

import { ReactNode } from 'react';

import { GeoFeature } from '@/types';

import { GeoContextData } from './context';

export type StaticGeoDataProviderProps = {
    children: ReactNode;
    data: GeoFeature;
};

export function StaticGeoDataProvider({
    children,
    data,
}: StaticGeoDataProviderProps) {
    return (
        <GeoContextData.Provider value={data}>
            {children}
        </GeoContextData.Provider>
    );
}
